import { render, staticRenderFns } from "./modelling-model-list.vue?vue&type=template&id=359dfd38&"
import script from "./modelling-model-list.vue?vue&type=script&lang=js&"
export * from "./modelling-model-list.vue?vue&type=script&lang=js&"
import style0 from "./modelling-model-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports